import { CartItem } from "@omni/types/api/cart/bff/shared/cartItem.model";
import { Product } from "@omni/types/api/product/bff/product.model";
import { ProductFieldSet } from "@omni/types/api/product/bff/shared/enums/productFieldSet.enum";
import { AnalyticsEvent } from "@omni/types/components/tracking/analyticsEvent";
import { EventType } from "@omni/types/components/tracking/eventType.enum";
import { AddToCartTrackingInfo } from "@omni/types/components/tracking/tracking-info/feature/addToCart.trackingInfo";

import * as CartItemMapper from "../../mappers/cartItem.mapper";
import * as productMapper from "../../mappers/product.mapper";
import * as ProductTileProductMapper from "../../mappers/productTileProduct.mapper";
import * as TrackingService from "../../tracking.service";

export const track = (trackingInfo: AddToCartTrackingInfo) => {
    const event: AnalyticsEvent<AddToCartTrackingInfo> = {
        event: EventType.AddToCart,
        payload: {
            eventData: trackingInfo
        }
    };

    TrackingService.track(event);
};

export const trackCartItem = (cartItem: CartItem, quantity: number) => {
    const trackingInfo = CartItemMapper.toAddToCartTrackingInfo({
        item: cartItem,
        quantity
    });

    track(trackingInfo);
};

export const trackProductTileProduct = (
    product: Product<ProductFieldSet.ProductTile>,
    quantity: number
) => {
    const trackingInfo = ProductTileProductMapper.toAddToCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};

export const trackECommerceProduct = (
    product: Product<ProductFieldSet.Full>,
    quantity: number
) => {
    const trackingInfo = productMapper.toAddToCartTrackingInfo({
        product,
        quantity
    });

    track(trackingInfo);
};
